export default "__VITE_ASSET__D4Z2AE9$__"